// import $ from "jquery";
import ajaxSubmit from "jquery-form";
import ajaxForm from "jquery-form";

import baseClass from "./base";
import generalTools from "./tools";

import toolsBootstrap from "./toolsBootstrap";

var CUSTOMFORMVAR = function () {
  this.currentformid = "";

  // ============================================================================
  this.afterSuccesFormSubmit = function (res, status, xhr) {
    customFormObj.currentformid = "";
    baseClass.processAjaxResultSuccessProcessCommands("", res, status, xhr);
    baseClass.OnReadyAll();
    baseClass.HideIsLoadingInProgress();
  };

  // ============================================================================
  this.afterErrorFormSubmit = function (res, status, xhr) {
    customFormObj.currentformid = "";
    baseClass.HideIsLoadingInProgress();
  };

  // ============================================================================
  this.manuallyBeforeFormSubmit = function (obj) {
    try {
      // CKEDITOR - updateElement
      //	for(var i in CKEDITOR.instances)
      //	{
      //		CKEDITOR.instances[i].updateElement();
      //	}
      obj.find('[class*="jsCkeditor"]').each(function () {
        var id = $(this).attr("id");
        var instance = CKEDITOR.instances[id];
        if (instance) {
          CKEDITOR.instances[id].updateElement();
        }
      });
    } catch (e) {
      console.log(e);
    }

    // -----------------------
    var hascutomcheckbox = obj.attr("hascutomcheckbox");
    var customcheckboxobjects = obj.attr("customcheckboxobjects");
    var cutomcheckboxname = obj.attr("cutomcheckboxname");

    if (hascutomcheckbox == "1") {
      $(customcheckboxobjects + ":checked").each(function () {
        obj.append(
          '<input type="hidden" data-generated="true" name="' +
            cutomcheckboxname +
            '" value="' +
            $(this).val() +
            '" /> ',
        );
      });
    }
    // -----------------------
  };

  // ============================================================================
  this.submitForm = function (obj) {
    var valfunc = obj.attr("data-valfunc");
    var aftfunc = obj.attr("data-aftfunc");
    if (valfunc) if (!eval(valfunc)) return false;
    var loadind = obj.attr("data-loadind");
    var targetid = obj.attr("data-targetid");
    if (!targetid) targetid = "main";
    if (loadind == undefined) {
      baseClass.ShowIsLoadingInProgress();
    } else {
      if (loadind == "mini") baseClass.putloadinindicator(targetid);
    }

    var href = obj.attr("action");
    var varResetForm = obj.attr("data-resetForm");
    if (varResetForm) varResetForm = true;
    else varResetForm = false;

    if (href.indexOf("?") >= 0) href += "&rt=ajax";
    else href += "?rt=ajax";

    href = href.replace("/?", "?");
    var lastChar = href[href.length - 1];
    if (lastChar == "/") {
      href = href.substring(0, href.length - 1);
    }

    var method = obj.attr("method");
    method = method == undefined ? "POST" : method;

    var enctype = obj.attr("enctype");
    enctype = enctype == undefined ? "multipart/form-data" : enctype;

    obj.attr("method", method);
    obj.attr("enctype", enctype);

    customFormObj.manuallyBeforeFormSubmit(obj);

    var options = {
      url: href,
      type: method,
      target: "#" + targetid,
      beforeSubmit: customFormObj.beforeFormSubmit,
      success: customFormObj.afterSuccesFormSubmit,
      error: customFormObj.afterErrorFormSubmit,
      resetForm: varResetForm,
    };

    if (obj.attr("data-closedialog") != undefined) {
      toolsBootstrap.bsCloseDialog(obj);
    }

    obj.ajaxSubmit(options);

    return false;
  };

  // ============================================================================
  // ============================================================================
  this.resetForm = function (id) {
    try {
      var obj = $("#" + id);
      if (!obj.length) return;

      // 1️⃣ Reset form fields
      obj.each(function () {
        if (this.tagName === "FORM") {
          this.reset();
        }
      });

      // 2️⃣ Reset currentformid (anti double submit)
      if (customFormObj.currentformid === id) {
        customFormObj.currentformid = "";
      }

      // 3️⃣ Remove custom hidden checkboxes (if appended)
      obj.find('input[type="hidden"][data-generated="true"]').remove();

      // 4️⃣ Reset CKEditor if exists
      try {
        obj.find('[class*="jsCkeditor"]').each(function () {
          var eid = $(this).attr("id");
          if (window.CKEDITOR && CKEDITOR.instances[eid]) {
            CKEDITOR.instances[eid].setData("");
          }
        });
      } catch (e) {
        console.log("CKEditor reset error", e);
      }

      // 5️⃣ Reset reCAPTCHA invisible
      var recaptchaObj = obj.find(".js_g_recaptcha_invisible");
      if (recaptchaObj.length) {
        recaptchaObj.removeClass("true");

        if (typeof grecaptcha !== "undefined") {
          try {
            grecaptcha.reset();
          } catch (e) {
            console.log("recaptcha reset error", e);
          }
        }
      }

      // 6️⃣ Remove loading indicators
      baseClass.HideIsLoadingInProgress();

      // 7️⃣ Enable submit button again (if disabled)
      obj
        .find("button[type='submit'], input[type='submit']")
        .prop("disabled", false);
    } catch (e) {
      console.log("err: resetForm", e);
    }
  };

  // ============================================================================
};;

var customFormObj = new CUSTOMFORMVAR();

export default customFormObj;

baseClass.OnReadyArrAdd(function () {
  $(".js_af").submit(function () {
    var fid = $(this).attr("id");
    if (customFormObj.currentformid == fid) return false;

    customFormObj.currentformid = fid;

    // --------------------------------------
    if ($(this).find(".js_g_recaptcha_invisible").length) {
      var robj = $(this).find(".js_g_recaptcha_invisible").first();
      if (!robj.hasClass("true")) {
        robj.addClass("true");
        grecaptcha.execute();
      }
      return false;
    }
    // --------------------------------------

    return customFormObj.submitForm($(this));
  });

  $(".js_af").each(function () {
    if ($(this).hasClass("true_js_af")) return;
    var obj = $(this);
    obj.addClass("true_js_af");

    var currentformid = $(this).attr("id");
    if (currentformid == undefined) {
      currentformid = generalTools.uuidv4();
      obj.attr("id", currentformid);
    }

    var method = $(this).attr("method");
    if (method == undefined) {
      method = "POST";
      obj.attr("method", method);
    }

    ajaxForm($(this));
  });
});
